import React from 'react';

type PdfSource = { base64: string; url?: never } | { url: string; base64?: never };

export type DocumentPdfPreviewProps = PdfSource & {
  /** The accessible name of the embedded document. */
  label: string;
  className?: string;
  style?: React.CSSProperties;
  /** Fires once the browser has loaded the document. */
  onLoad?: () => void;
  /** Shown where the browser cannot display a PDF. */
  children?: React.ReactNode;
};

/** A PDF in the browser's own viewer, from base64 the server sent or from a URL it serves. */
const DocumentPdfPreview: React.FC<DocumentPdfPreviewProps> = ({
  base64,
  url,
  label,
  className,
  style,
  onLoad,
  children,
}) => (
  <object
    className={className}
    style={style}
    aria-label={label}
    data={base64 !== undefined ? `data:application/pdf;base64,${base64}` : url}
    type="application/pdf"
    onLoad={onLoad}
  >
    {children}
  </object>
);

export default DocumentPdfPreview;
